import { use } from "react";
import { ConfirmDialogContext } from "./confirm-dialog-provider";

const useConfirm = () => {
    return use(ConfirmDialogContext);
};

export { useConfirm };
